module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/icons/social/youtube-default@2x.png?6c22c72ba78829d34a9e13a513e8f28e";